
    const _ = require("underscore");
    module.exports = function(context){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="fullscreen-gallery" is="fullscreen-gallery"><div class="fullscreen-overlay"><div class="fullscreen-overlay-left"><div is="slide-control" selected-index="'+
((__t=( context.selectedItemIndex ))==null?'':_.escape(__t))+
'" white-loading-indicator="true" ';
 if (context.options.zoomEnabled) { 
__p+='zoom-enabled="true"';
 } 
__p+=' items=\''+
((__t=( JSON.stringify(context.items) ))==null?'':_.escape(__t))+
'\'></div>';
 if (context.items.length > 1) { 
__p+='<button class="fullscreen-overlay-prev hidden-tablet" type="button" data-prev-button><div class="fullscreen-overlay-prev-glyph glyph glyph-large glyph-chevron-white glyph-mirror-x"></div></button><button class="fullscreen-overlay-next hidden-tablet" type="button" data-next-button><div class="fullscreen-overlay-next-glyph glyph glyph-large glyph-chevron-white"></div></button>';
 } 
__p+='</div><div class="fullscreen-overlay-right"><ul class="fullscreen-overlay-thumbnails">';
 if (context.items.length > 1) { 
__p+='';
 _.each(context.items, function(item, idx) { 
__p+='';
 if (item.type === 'image') { 
__p+='<li class="fullscreen-overlay-thumbnail-item"><a href="'+
((__t=( item.full_size_url ))==null?'':_.escape(__t))+
'" class="fullscreen-overlay-thumbnail" data-item-id="'+
((__t=( idx ))==null?'':_.escape(__t))+
'"><img is="lazy-image" image-src="'+
((__t=( item.thumbnail_url ))==null?'':_.escape(__t))+
'" /></a></li>';
 } 
__p+='';
 }) 
__p+='';
 } 
__p+='';
 if (context.viewSimilarEnabled) { 
__p+='<li class="fullscreen-overlay__view-similar"><div class="fullscreen-overlay-inner"><h3 class="mb15">'+
((__t=( context.soldOutTitle ))==null?'':_.escape(__t))+
'</h3><a href="#relatedproducts" class="btn btn--full-width">'+
((__t=( context.seeSimilarItemsBtnText ))==null?'':_.escape(__t))+
'</a><div class="fullscreen-overlay__or-block"><span>'+
((__t=( context.orSeparator ))==null?'':_.escape(__t))+
'</span></div><div>'+
((__t=( context.seeNewItemsByDesignerHTML ))==null?'':__t)+
'</div></div></li>';
 } 
__p+='';
 if (context.retailer) { 
__p+='<li class="fullscreen-overlay__buy"><div class="fullscreen-overlay-inner"><span class="fullscreen-overlay-price heading-2 block mb10">';
 if (context.retailer.sale_price) { 
__p+='<del>'+
((__t=( context.retailer.price ))==null?'':_.escape(__t))+
'</del><span class="price sale">'+
((__t=( context.retailer.sale_price ))==null?'':_.escape(__t))+
'</span>';
 } else { 
__p+=''+
((__t=( context.retailer.price ))==null?'':_.escape(__t))+
'';
 } 
__p+='</span><span class="fullscreen-overlay-retailer block mb15">'+
((__t=( context.atRetailerText ))==null?'':_.escape(__t))+
'</span><a href="'+
((__t=( context.retailer.url ))==null?'':_.escape(__t))+
'" class="btn btn--full-width" target="_blank" is="lead-link" reason="fullscreen-overlay-button">'+
((__t=( context.buyBtnText ))==null?'':_.escape(__t))+
'</a></div></li>';
 } 
__p+='</ul></div><div class="fullscreen-overlay-indicators"><div is="slide-indicators"max-slides="'+
((__t=( context.items.length ))==null?'':_.escape(__t))+
'"selected-index="'+
((__t=( context.selectedItemIndex ))==null?'':_.escape(__t))+
'"></div></div><button type="button" class="fullscreen-overlay-close glyph glyph-medium glyph-cross-white"><span class="fullscreen-overlay-close-text">'+
((__t=( context.closeBtnText ))==null?'':_.escape(__t))+
'</span></button></div></div>';
return __p;
};
    